import React from 'react';
import { TextArea } from '@components/main-components/forms/inputs/TextArea/TextArea';
import { COMMENT_MAX_CHARS } from '@utils/constants';
import { DataTestId } from '@utils/test';

export function CommentTextArea({
  commentText,
  setCommentText,
  isLoading,
}: {
  commentText: string;
  setCommentText: (text: string) => void;
  isLoading?: boolean;
}) {
  const commentErr = commentText.length > COMMENT_MAX_CHARS;

  return (
    <div className="grid w-full">
      <TextArea
        data-testid={DataTestId.SET_COMMENT_MODAL_TESTAREA}
        placeholder={isLoading ? '...' : 'What would you like to comment...'}
        onChange={e => {
          setCommentText(e.target.value);
        }}
        hasError={!!commentErr}
        errorMsg={'Exceeds maximum character limit of ' + COMMENT_MAX_CHARS}
        value={commentText}
        disabled={isLoading}
        className="mb-1 w-full md:justify-end"
      />
    </div>
  );
}
